export type ConnectionStatus = "disconnected" | "connecting" | "connected" | "reconnecting" | "error";

export interface SignalRSensorData {
	messageId: string;
	companyId: string;
	deviceId: string;
	siteId: string;
	unitId: string;
	dataTypeName: string;
	measurement: string;
	dateTime: string;
	receivedDateTime: string;
	processedDateTime: string;
	value: number;
	isValueValid: boolean;
	depth?: number;
	metadata?: {
		previous?: number;
	};
	source?: {
		system: string;
	};
}

export interface SensorValue {
	value: number;
	timestamp: string;
	siteId: number;
	dataType: string;
	measurement: string;
	isValid: boolean;
	depth?: number;
}

export type SensorDataMap = Record<string, SensorValue>;

export type UnitSensorMap = Record<number, SensorDataMap>;

export const WorkerMessageType = {
	ConnectionId: "CONNECTION_ID",
	Error: "ERROR",
	Reconnect: "RECONNECT",
	SensorData: "SENSOR_DATA",
	Pong: "PONG",
} as const;

export const WorkerCommand = {
	Initialize: "INITIALIZE",
	SetToken: "SET_TOKEN",
	Stop: "STOP",
	Terminate: "TERMINATE",
	Ping: "PING",
	Subscribe: "SUBSCRIBE",
	Unsubscribe: "UNSUBSCRIBE",
} as const;

export interface ConnectionIdMessage {
	type: "CONNECTION_ID";
	payload: {
		connectionId: string;
	};
}

export interface ErrorMessage {
	type: "ERROR";
	payload: {
		error: string;
		details?: unknown;
	};
}

export interface ReconnectMessage {
	type: "RECONNECT";
}

export interface SensorDataMessage {
	type: "SENSOR_DATA";
	payload: SignalRSensorData[];
}

export interface PongMessage {
	type: "PONG";
}

export type WorkerMessage = ConnectionIdMessage | ErrorMessage | ReconnectMessage | SensorDataMessage | PongMessage;

export interface InitializeCommand {
	command: "INITIALIZE";
	signalRUrl: string;
}

export interface SetTokenCommand {
	command: "SET_TOKEN";
	token: string;
}

export interface StopCommand {
	command: "STOP";
}

export interface TerminateCommand {
	command: "TERMINATE";
}

export interface PingCommand {
	command: "PING";
}

export interface SubscribeCommand {
	command: "SUBSCRIBE";
	siteIds: number[];
}

export interface UnsubscribeCommand {
	command: "UNSUBSCRIBE";
}

export type WorkerCommandMessage =
	| InitializeCommand
	| SetTokenCommand
	| StopCommand
	| TerminateCommand
	| PingCommand
	| SubscribeCommand
	| UnsubscribeCommand;

export interface SignalRInitOptions {
	signalRUrl: string;
	getAccessToken: () => Promise<string>;
}

export interface SignalRError {
	message: string;
	timestamp: string;
	details?: unknown;
}
